import { render, staticRenderFns } from "./DisplaySchedule.vue?vue&type=template&id=d87d0b8e"
import script from "./DisplaySchedule.vue?vue&type=script&lang=js"
export * from "./DisplaySchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports